import axios from 'axios'
import './common'

export default {
    getRoot: (params) => axios.get(`/folders`, { params: params }),
    newFolder: (params) => axios.post(`/folders`, { param: params }),
    getFolder: (id, params) => axios.get(`/folders/${id}`, { params: params }),
    updateFolder: (id, params) => axios.put(`/folders/${id}`, { param: params }),
    deleteFolder: (id) => axios.delete(`/folders/${id}`),
    deleteFolderContent: (id, params) => axios.delete(`/folders/${id}/multi`, { param: params }),
    newFile: (params) => axios.post(`/files`, params),
    getFile: (id) => axios.get(`/files/${id}`, { responseType: "blob" }),
    updateFile: (id, params) => axios.put(`/files/${id}`, { param: params }),
    deleteFile: (id) => axios.delete(`/files/${id}`),
    generatePreview: (id) => axios.get(`/files/${id}/preview`),
}